import { render, staticRenderFns } from "./ProductQuantityInput.vue?vue&type=template&id=97865d20&"
import script from "./ProductQuantityInput.vue?vue&type=script&lang=js&"
export * from "./ProductQuantityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports